// extracted by mini-css-extract-plugin
export var statItem = "_fz-1";
export var statsRow = "_fz-0";